import React from 'react';
import styled from 'styled-components';
import dedent from 'dedent';

import UniversalGridder from '$styles/universal-gridder';
import { glsp, themeVal } from '@devseed-ui/theme-provider';

const ErrorBlockSelf = styled.div`
  grid-column: content-start / content-end;
  border: 4px solid ${themeVal('color.danger')};
  border-radius: ${themeVal('shape.rounded')};
  padding: ${glsp(2)};
  display: flex;
  flex-flow: column nowrap;
  gap: ${glsp(2)};

  > * {
    max-width: 48rem;
  }
`;

const ErrorBlockTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: ${themeVal('type.base.bold')};
  font-variation-settings:
    'wdth' 24,
    'wght' 640;
  text-transform: uppercase;
  color: ${themeVal('color.danger')};
`;

const ErrorHint = styled.p`
  font-size: 0.875rem;
`;

interface ErrorBlockProps {
  title?: string;
  hint?: string | false;
  children?: React.ReactNode;
}

export function ErrorBlock(props: ErrorBlockProps) {
  const { title, hint, children } = props;

  return (
    <UniversalGridder>
      <ErrorBlockSelf>
        <ErrorBlockTitle>
          {title || '🧱 Oh no! Your block is broken'}
        </ErrorBlockTitle>
        <div>{children || 'Unknown error. Please check the block.'}</div>
        {hint !== false && (
          <ErrorHint>
            {hint ||
              '🍀 Check the documentation on the repo for all the details.'}
          </ErrorHint>
        )}
      </ErrorBlockSelf>
    </UniversalGridder>
  );
}

const ErrorCodeSelf = styled.pre`
  border: 1px solid ${themeVal('color.base-200a')};
  padding: ${glsp()};

  code {
    display: block;
    overflow-x: auto;
  }
`;

export function ErrorCode(props: { children: string }) {
  const { children } = props;

  return (
    <ErrorCodeSelf>
      <code>{dedent(children)}</code>
    </ErrorCodeSelf>
  );
}
